import styled, { css } from "styled-components";

import { ViewfinderProps } from "@/components/GalleryUploader/Camera/Camera.types";

export const StyledViewfinder = styled.div<ViewfinderProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    aspect-ratio: 16 / 14;
    width: 85%;
    max-width: 400px;
    max-height: 70%;

    background: transparent;
    box-shadow: 0 0 0 9999px ${({ theme }) => `${theme.colors.black}32`};
    border: 2px solid
        ${({ theme, $levelOk, $oriEnabled }) => {
            if (!$oriEnabled) {
                return theme.colors.white;
            }

            return $levelOk
                ? theme.successTypographyColor
                : theme.dangerTypographyColor;
        }};
    border-radius: 16px;

    &::before {
        content: "";
        position: absolute;
        inset: 8px;
        border: 1px solid
            ${({ theme, $levelOk, $oriEnabled }) => {
                if (!$oriEnabled) {
                    return `${theme.colors.white}80`;
                }

                return $levelOk
                    ? `${theme.successTypographyColor}80`
                    : `${theme.dangerTypographyColor}80`;
            }};
        border-radius: 12px;
    }

    &::after {
        content: "+";
        font-size: 64px;
        line-height: 64px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.2;
        color: ${({ theme, $levelOk, $oriEnabled }) => {
            if (!$oriEnabled) {
                return theme.colors.white;
            }

            return $levelOk
                ? theme.successTypographyColor
                : theme.dangerTypographyColor;
        }};
    }

    .help-text {
        ${({ theme, $oriEnabled, $levelOk }) => {
            if (!$oriEnabled || $levelOk) {
                return css`
                    opacity: 0;
                `;
            }

            return css`
                position: absolute;
                top: -35px;
                width: max-content;
                left: 50%;
                transform: translateX(-50%);
                color: ${theme.primaryTypographyColor};
                background: ${theme.dangerTypographyColor}CC;
                padding: 4px 8px;
                border-radius: 8px;
                opacity: 1;
                transition: all ease 300ms;
            `;
        }}
    }
`;
